<div id="pswd_info" [hidden]="!this.validator">
    <h4>Requerimientos de contraseña:</h4>
    <ul>
        <li id="capital" [className]="this.capitalLetter===true ? 'valid' : 'invalid'" class="">Al menos una <strong>letra en mayúscula</strong></li>
        <li id="capital2"[className]="this.lowerCase===true ? 'valid' : 'invalid'">Al menos una <strong>letra en minúscula</strong></li>
        <li id="number" [className]="this.specialCharacterNumber===true ? 'valid' : 'invalid'">Al menos <strong>un número o un carácter especial</strong></li>
        <li id="length" [className]="this.characterLength===true ? 'valid' : 'invalid'">Debe tener al menos <strong>8 caracteres</strong></li>
    </ul>
    <h4 style="padding-top:5px;height: auto;">NOTA: Su contraseña no puede ser la misma de su dirección de email / usuario</h4>
</div>